import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const scrollToCheckout = () => {
  const checkoutButton = document.getElementById('checkout-button');
  if (checkoutButton) {
    checkoutButton.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  }
};
const benefits = ['Unidades completas', 'Actividades profesionales', 'Simulacros reales', 'Evaluaciones listas', 'Checklists técnicos', 'Todo editable e imprimible'];
export function SolutionSection() {
  return <section className="py-20 bg-blue-900 text-white relative overflow-hidden" data-id="element-159">
      {/* Background Elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-blue-600 rounded-full blur-3xl opacity-20 -translate-y-1/2 translate-x-1/2" data-id="element-160"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-yellow-500 rounded-full blur-3xl opacity-10 translate-y-1/2 -translate-x-1/2" data-id="element-161"></div>

      <div className="container mx-auto px-4 text-center relative z-10" data-id="element-162">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-4xl mx-auto" data-id="element-163">
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-164">
            Por eso creamos el{' '}
            <span className="text-yellow-400" data-id="element-165">
              Mega Pack Seguridad e Higiene
            </span>
          </h2>
          <p className="text-xl md:text-2xl text-blue-100 mb-12 font-light" data-id="element-166">
            Sistema completo de formación anual listo para usar.{' '}
            <br className="hidden md:block" data-id="element-167" />
            <span className="font-bold text-white" data-id="element-168">
              Menos preparación. Más clases que funcionan.
            </span>
          </p>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-8 mb-12" data-id="element-169">
            {benefits.map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-blue-800/50 backdrop-blur-sm border border-blue-700 p-4 rounded-lg flex flex-col items-center justify-center gap-3 hover:bg-blue-700/50 transition-colors" data-id="element-170">
                <CheckCircle2 className="w-8 h-8 text-green-400" data-id="element-171" />
                <span className="font-bold text-lg" data-id="element-172">{benefit}</span>
              </motion.div>)}
          </div>

          <motion.button onClick={scrollToCheckout} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="bg-yellow-400 text-blue-900 text-xl md:text-2xl font-bold py-4 px-10 rounded-full shadow-[0_0_20px_rgba(250,204,21,0.5)] hover:bg-yellow-300 transition-all cursor-pointer" data-id="element-173">
            ACCEDER AL MEGA PACK HOY
          </motion.button>
        </motion.div>
      </div>
    </section>;
}